// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Highlights_TheComp__w0bLQ"};